import {
  IUserType,
  useQueryUnlockedWorkoutGet,
  IDashboardEquipmentType,
} from '@ifit/gateway-wolf-dashboard-service';
import { IMembershipType } from '@ifit/gateway-wolf-athenaeum-service';
import { parseDashboardEquipmentType } from '@ifit/equipment-types';
import { useEquipmentType } from '../equipment-type';
import {
  useBasicAuthOptions,
  useRequiredRequestOptions,
} from '../query-options';
import { IEquipmentType } from '@ifit/gateway-workout-store';

function instanceOfDashboardEquipmentType(
  equipmentType: IEquipmentType,
): boolean {
  return equipmentType in IDashboardEquipmentType;
}

export const useUnlockedWorkout = (): string => {
  const { softwareNumber, membershipType } = useRequiredRequestOptions();
  const { equipmentType } = useEquipmentType();
  const userType =
    membershipType === IMembershipType.Free
      ? IUserType.Free
      : IUserType.Premium;
  const { data } = useQueryUnlockedWorkoutGet(
    {
      softwareNumber,
      userType,
      equipmentType: parseDashboardEquipmentType(equipmentType) as any,
      ...useBasicAuthOptions(),
    },
    {
      cacheTime: 5 * 60 * 1000,
      staleTime: 5 * 60 * 1000,
      enabled: instanceOfDashboardEquipmentType(equipmentType),
    },
  );

  return data?.unlockedWorkoutId;
};
